export default {
  '@type': 'MerchantReturnPolicy',
  'applicableCountry': 'BE',
  'merchantReturnLink': 'https://www.timberland.be/de-be/kundenservice/ruckversand',
  'returnPolicyCategory': 'https://schema.org/MerchantReturnFiniteReturnWindow',
  'returnMethod': 'https://schema.org/ReturnByMail',
  'merchantReturnDays': 30
}
